var React = require("react");
var ApplicationContext = require("../../config/ApplicationContext.js");

 class EmptyTrashCard extends React.Component {

    render() {
        return (
        	<div>
                <div className="empty">
                <p>Trash is empty.</p>
                </div>
            </div>
        );
    }
}


module.exports = EmptyTrashCard;
